import api from "!../../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../css-loader/dist/cjs.js??ref--21-1!./snippetSession.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};